import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { isVisitorCookiesAllowed } from './CookieConsent';

const RouteTracker = () => {
  const location = useLocation();
  const getApiUrl = () => {
    return "/api"; // Standardized API base path
  };

  const API_URL = getApiUrl(); // Use standardized API URL


  useEffect(() => {
    const trackPageVisit = async () => {
      // Always allow for authenticated users
      const isAuthenticated = !!localStorage.getItem("authToken");
      if (!isAuthenticated && !isVisitorCookiesAllowed()) {
        return; // Do not track visits for visitors who rejected cookies
      }

      let currentPath = location.pathname.replace(/^\/+/, ""); // Remove leading "/"

      // Map frontend paths to backend expectations
      const pathMappings = {
        "": "home",
        "home": "home",
        "imoveis": "imoveis",
        "outros": "outros",
        "contacts": "contacts",
        "privacy-policy": "privacy-policy"
      };

      const mappedPath = pathMappings[currentPath] || null;

      if (!mappedPath) {
        console.warn("Untracked route:", currentPath);
        return;
      }

      try {
        // POST request to the "track-visit" endpoint with correct property name
        await axios.post(`${API_URL}/dashboard/track-visit`, 
          { Path: mappedPath }, 
          { withCredentials: true }
        );        
      } catch (error) {
        console.error("Error tracking page visit:", error);
      }
    };

    trackPageVisit();
  }, [location]);

  return null;
};

export default RouteTracker;
